import { providersDetails } from 'bzx-common/src/domain/ProviderTypeDictionary'
import { observer } from 'mobx-react'
import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Icon, Tooltip } from 'ui-framework'
import ProviderInfoVM from './ProviderInfoVM'

/**
 * Change provider info found in the navbar
 */

export function ProviderInfo({ vm }: { vm: ProviderInfoVM }) {
  const tooltip = React.useRef(null)
  const { web3Connection } = vm.rootStore
  const { supportedWalletProviders, providerTypeDetails } = web3Connection
  const providerTypes = supportedWalletProviders
  const ProviderLogoIcon = providerTypeDetails.ProviderLogo
  return (
    <Tooltip
      id="provider-info"
      className="header-dropdown panel--simple flex-col padded-15"
      place={'bottom'}
      clickable={true}
      effect="solid"
      globalEventOff="click"
      data-event-off="click"
      isCapture={true}
      ref={tooltip}
      delayHide={200}>
      {!web3Connection.isConnected && (
        <div className="margin-bottom-05">
          {providerTypes
            .filter((item) => web3Connection.providerType !== item)
            .map((providerType) => {
              const providerTypeDetails = providersDetails[providerType]
              const ProviderLogoIcon = providerTypeDetails.ProviderLogo
              return (
                <Button
                  key={providerTypeDetails.label}
                  variant="menu"
                  onClickEmit="value"
                  value={providerType}
                  onClick={vm.connect}>
                  <ProviderLogoIcon className="margin-right-1" height="24" />
                  {providerTypeDetails.label}
                </Button>
              )
            })}
        </div>
      )}

      {web3Connection.isConnected && (
        <>
          <Link to="/user-profile" className="btn btn--menu justify-center">
            <Icon
              size={26}
              name="User"
              color="var(--color-txt-muted)"
              className="margin-right-05"
            />
            <span>Profile</span>
          </Link>
          <hr className="content-separator margin-v-05" />
          <Button
            variant="menu"
            onClick={vm.disconnect}
            className="justify-center margin-bottom-05">
            <ProviderLogoIcon className="on-chain-indicator--provider-logo margin-right-05" />{' '}
            Disconnect
          </Button>
        </>
      )}
    </Tooltip>
  )
}

export default observer(ProviderInfo)
